import React from 'react'
import { Button } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import useCan from '@shared/permissions/useCan';
import ListPageHeader from '@shared/ListPageHeader'
import InventoryHoldList from '@shared/inventory/InventoryHoldList'
import { inventoryHoldService } from '@services/admin/inventoryHoldService'

export default function List() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const can = useCan();

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['stocks', 'stocks.inventory_holds']}
        actions={
          can('inventories:write') && (
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => navigate('/inventory_holds/new')}
            >
              {t('common.button.new')}
            </Button>
          )
        }
      />
      <InventoryHoldList
        service={inventoryHoldService}
        role="admin"
        merchants={[]}
      />
    </div>
  )
}
